import React, { useEffect, useState, useRef } from "react";
import { createPopper } from "@popperjs/core";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const UserDropdown = () => {
  const [dropdownPopoverShow, setDropdownPopoverShow] = useState(false);
  const [admin, setAdmin] = useState(null);

  const btnDropdownRef = useRef(null);
  const popoverDropdownRef = useRef(null);

  const navigate = useNavigate();

  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };

  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  // Fetch the admin data on initial load
  const fetchAdmin = async () => {
    const adminId = localStorage.getItem("adminId");
    if (!adminId) return;

    try {
      const formData = new FormData();
      formData.append("AdminId", adminId);

      const response = await axios.post(
        "https://visitguru.in/api/v1/admin/getAdmin",
        formData
      );

      if (response.data && response.data.success) {
        setAdmin(response.data.data); // Set admin data from API
      } else {
        console.error("Admin fetch failed:", response.data.message);
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };

  useEffect(() => {
    fetchAdmin();

    // Add event listener to detect click outside the dropdown
    const handleClickOutside = (event) => {
      if (
        popoverDropdownRef.current &&
        !popoverDropdownRef.current.contains(event.target) &&
        !btnDropdownRef.current.contains(event.target)
      ) {
        setDropdownPopoverShow(false); // Close dropdown if click is outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []); // Runs only once on mount

  const handleProfileUpdate = async (updatedAdminData) => {
    try {
      // Make the API call to update the admin profile
      const adminId = localStorage.getItem("adminId");
      const formData = new FormData();
      formData.append("AdminId", adminId);
      // Add any additional form data needed for profile update here

      const response = await axios.post(
        "https://visitguru.in/api/v1/admin/updateAdmin", // Replace with your update API endpoint
        formData
      );

      if (response.data && response.data.success) {
        // Update the `admin` state immediately after a successful update
        setAdmin(response.data.data); // Directly set the new admin data here
        alert("Profile updated successfully!");
      } else {
        console.error("Admin update failed:", response.data.message);
      }
    } catch (error) {
      console.error("Error during admin profile update:", error);
    }
  };

  return (
    <>
      <a
        className="text-blueGray-500 block"
        href="#pablo"
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        <div className="items-center flex">
          <span className="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full">
            {admin?.image ? (
              <img
                alt="Admin"
                className="w-full rounded-full align-middle border-none shadow-lg"
                src={admin.image}
              />
            ) : (
              <span className="text-xs text-blueGray-700">👤</span>
            )}
          </span>
        </div>
      </a>
      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
        }
      >
        {admin && (
          <div className="px-4 py-2 text-sm text-blueGray-700 font-semibold border-b border-blueGray-100">
            {admin.fullName || "Admin Name"}
          </div>
        )}
        <a
          href="#profile"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          onClick={(e) => {
            e.preventDefault();
            navigate("/admin/update");
          }}
        >
          Profile
        </a>

        <a
          href="#changepassword"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          onClick={(e) => {
            e.preventDefault();
            navigate("/admin/change-password");
          }}
        >
          Change Password
        </a>

        <div className="h-0 my-2 border border-solid border-blueGray-100" />

        <a
          href="#logout"
          className="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          onClick={(e) => {
            e.preventDefault();
            localStorage.removeItem("adminId");
            window.location.href = "/auth/login";
          }}
        >
          Logout
        </a>
      </div>
    </>
  );
};

export default UserDropdown;
